/*
 * Copyright (c) 2018-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

import React, { useEffect, useRef, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { useOktaAuth } from '@okta/okta-react';
import * as OktaSignIn from '@okta/okta-signin-widget';
import '@okta/okta-signin-widget/dist/css/okta-sign-in.min.css';

import config from '../config';
import axios from 'axios';

const Login = (props) => {
	const [formData, setFormData] = useState({ username: "", password: "" });
	const [formErrors, setFormErrors] = useState([]);
	const [formStatus, setFormStatus] = useState({
		submitted: false,
		alert: {
			show: false,
			type: "",
			message: ""
		}
	});
	// const { oktaAuth } = useOktaAuth();
	// const widgetRef = useRef();

	// useEffect(() => {
	// 	if (!widgetRef.current) {
	// 		return false;
	// 	}

	// 	const { issuer, clientId, redirectUri, scopes, useInteractionCode } = config.oidc;
	// 	const widget = new OktaSignIn({
	// 		/**
	// 		 * Note: when using the Sign-In Widget for an OIDC flow, it still
	// 		 * needs to be configured with the base URL for your Okta Org. Here
	// 		 * we derive it from the given issuer for convenience.
	// 		 */
	// 		baseUrl: issuer.split('/oauth2')[0],
	// 		clientId,
	// 		redirectUri,
	// 		// logo: `${process.env.PUBLIC_URL}/react.svg`,
	// 		i18n: {
	// 			en: {
	// 				'primaryauth.title': 'Emapta Inquiry Form Admin',
	// 			},
	// 		},
	// 		authParams: {
	// 			// To avoid redirect do not set "pkce" or "display" here. OKTA-335945
	// 			issuer,
	// 			scopes,
	// 		},
	// 		useInteractionCodeFlow: useInteractionCode, // Set to true, if your org is OIE enabled
	// 	});

	// 	widget.renderEl(
	// 		{ el: widgetRef.current },
	// 		(res) => {
	// 			oktaAuth.handleLoginRedirect(res.tokens);
	// 		},
	// 		(err) => {
	// 			throw err;
	// 		},
	// 	);

	// 	// Note: Can't distinguish CORS error from other network errors
	// 	const isCorsError = (err) => (err.name === 'AuthApiError' && !err.statusCode);

	// 	widget.on('afterError', (_context, error) => {
	// 		if (isCorsError(error)) {
	// 			setCorsErrorModalOpen(true);
	// 		}
	// 	});

	// 	return () => widget.remove();
	// }, [oktaAuth]);


	const submitFormHandler = e => {
		e.preventDefault();

		let errors = [];
		if (formData.username === "") {
			errors.push('username');
		}

		if (formData.password === "") {
			errors.push('password');
		}

		if (errors.length > 0) {
			setFormErrors(errors);
		} else {
			setFormErrors([]);
			setFormStatus({ ...formStatus, submitted: true });
			axios.post('/api/auth', formData)
				.then(response => {
					let { status, token, user } = response.data;
					// console.log(token, user);
					localStorage.setItem('access-token', token);
					localStorage.setItem('user', JSON.stringify(user));
					props.history.push('/admin');
				}).catch(err => {
					let { data, error, status } = err.response.data;
					setFormStatus({
						...formStatus,
						submitted: false,
						alert: {
							show: true,
							type: "danger",
							message: error
						}
					})
				})
		}

	}


	return (
		<main className="form-signin">
			<form>
				<h1 className="h3 mb-3 fw-normal" style={{ margin: 0, padding: 0 }}>Active Directory Login</h1>

				{formStatus.alert.show &&
					<div className={`alert alert-${formStatus.alert.type}`} role="alert">
						{formStatus.alert.message}
					</div>
				}

				<div className="form-floating">

					<input
						type="text"
						className={`form-control ${formErrors.includes('username') ? 'is-invalid' : ""}`}
						id="username"
						name="username"
						placeholder="name@example.com"
						value={formData.username}
						onChange={e => setFormData({ ...formData, [e.target.name]: e.target.value })}
						disabled={formStatus.submitted}
					/>
					<label htmlFor="username">Username</label>
				</div>
				<div className="form-floating mt-3">
					<input
						type="password"
						className={`form-control ${formErrors.includes('password') ? 'is-invalid' : ""}`}
						id="password"
						name="password"
						placeholder="Password"
						value={formData.password}
						onChange={e => setFormData({ ...formData, [e.target.name]: e.target.value })}
						disabled={formStatus.submitted}
					/>
					<label htmlFor='password'>Password</label>
				</div>
				<button
					className="w-100 btn btn-lg btn-primary"
					type="submit"
					disabled={formStatus.submitted}
					onClick={e => submitFormHandler(e)}
				>Sign in</button>
			</form>
		</main>
	);
};

export default withRouter(Login);
